/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartSimulationResponse
 */
export interface StartSimulationResponse {
    /**
     * The Job id that can be used to poll the progress of the simulation import
     * @type {string}
     * @memberof StartSimulationResponse
     */
    jobId: string;
    /**
     * 
     * @type {number}
     * @memberof StartSimulationResponse
     */
    simulationId: number;
}

/**
 * Check if a given object implements the StartSimulationResponse interface.
 */
export function instanceOfStartSimulationResponse(value: object): value is StartSimulationResponse {
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    if (!('simulationId' in value) || value['simulationId'] === undefined) return false;
    return true;
}

export function StartSimulationResponseFromJSON(json: any): StartSimulationResponse {
    return StartSimulationResponseFromJSONTyped(json, false);
}

export function StartSimulationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartSimulationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
        'simulationId': json['simulationId'],
    };
}

export function StartSimulationResponseToJSON(json: any): StartSimulationResponse {
    return StartSimulationResponseToJSONTyped(json, false);
}

export function StartSimulationResponseToJSONTyped(value?: StartSimulationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobId': value['jobId'],
        'simulationId': value['simulationId'],
    };
}

